import { cn } from '@/app/utils/cn'

interface InfoRowProps {
  label: string
  value?: string | null
  className?: string
}

export const InfoRow = ({ label, value, className }: InfoRowProps) => (
  <div
    className={cn(
      'grid grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] items-center gap-4 lg:grid-cols-[9rem_minmax(0,1fr)]',
      className,
    )}
  >
    <p className="text-sm text-black04">{label}</p>
    <p className="text-sm font-semibold text-black03">{value || '-'}</p>
  </div>
)
